import Constants from '../../../app/utils/constants'
import IndustryCircle from '../../atoms/IndustryCircle/IndustryCircle'
import { useNavigate } from 'react-router-dom'
import arrowicon from '../../../assets/images/icons/arrowicon.svg'
import { useEffect, useRef, useState } from 'react'


const Industries = () => {
  const navigate = useNavigate()
  const { industries } = Constants


  const blobRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const [isInside, setIsInside] = useState(false)


  useEffect(() => {
    let mouseX = 0
    let mouseY = 0
    let currentX = 0
    let currentY = 0
    let rafId = 0


    const container = containerRef.current
    if (!container) return


    const handleMouseMove = (e: MouseEvent) => {
      const rect = container.getBoundingClientRect()


      mouseX = e.clientX - rect.left
      mouseY = e.clientY - rect.top
    }


    const handleEnter = () => setIsInside(true)
    const handleLeave = () => setIsInside(false)


    const animate = () => {
      currentX += (mouseX - currentX) * 0.08
      currentY += (mouseY - currentY) * 0.08


      if (blobRef.current) {
        blobRef.current.style.transform = `translate(calc(${currentX}px - 50%), calc(${currentY}px - 50%))`
      }


      rafId = requestAnimationFrame(animate)
    }


    container.addEventListener('mousemove', handleMouseMove)
    container.addEventListener('mouseenter', handleEnter)
    container.addEventListener('mouseleave', handleLeave)


    rafId = requestAnimationFrame(animate)


    return () => {
      container.removeEventListener('mousemove', handleMouseMove)
      container.removeEventListener('mouseenter', handleEnter)
      container.removeEventListener('mouseleave', handleLeave)


      cancelAnimationFrame(rafId)
    }
  }, [])


  const outerCircleSizeClass =
    'w-40 h-40 sm:w-52 sm:h-52 md:w-60 md:h-60 lg:w-72 lg:h-72 xl:w-80 xl:h-80'


  const centerCircleSizeClass =
    'w-40 h-40 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 xl:w-80 xl:h-80'


  return (
    <div
      ref={containerRef}
      className="relative flex flex-col lg:flex-row items-center justify-between gap-10 px-4 md:px-10 py-10 h-[550px] md:min-h-[760px] overflow-hidden"
    >


      {/* BLOB */}
      <div
        ref={blobRef}
        className={`pointer-events-none absolute w-[500px] h-[650px] rounded-full bg-[radial-gradient(circle_at_center,#9e5ddfba,transparent_70%)] blur-3xl transition-opacity duration-500 ease-out ${isInside ? 'opacity-60' : 'opacity-0'}`}
      />


      {/* RIGHT SIDE */}
      <div className="relative order-1 lg:order-2 w-full lg:w-2/5 text-white space-y-4 flex flex-col items-center lg:items-start text-center lg:text-left">


        <button
          type="button"
          onClick={() => navigate('/industry')}
          className="group relative mb-4 cursor-pointer rounded-full border border-purple/80 bg-[#0b0636] px-6 py-2.5 font-rajdhani text-xs font-semibold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-purple/90 sm:px-7 sm:py-3 sm:text-sm md:px-8 md:py-3.5 md:text-base lg:px-10 lg:py-4 lg:text-lg xl:text-xl 2xl:text-2xl"
        >
          Industries


          <img
            src={arrowicon}
            alt=""
            aria-hidden
            className="pointer-events-none absolute right-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 object-contain transition-transform duration-200 group-hover:translate-x-0.5 sm:right-3.5 sm:h-4 sm:w-4 md:right-4 md:h-4.5 md:w-4.5 lg:right-4.5 lg:h-5 lg:w-5"
          />
        </button>


        <h2 className="w-full max-w-[16ch] font-rajdhani xl:text-5xl font-semibold leading-tight text-3xl sm:text-4xl md:text-4xl lg:text-5xl">
          Deep Domain Expertise
        </h2>


      </div>


      {/* LEFT SIDE */}
      <div className="relative order-2 lg:order-1 w-full lg:w-3/5 max-w-[760px] h-[360px] sm:h-[440px] md:h-[520px] lg:h-[600px] mx-auto flex items-center justify-center">


        {/* CENTER CIRCLE */}
        <div className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 ${centerCircleSizeClass} bg-purple rounded-full flex flex-col items-center justify-center text-white p-3 md:p-12 z-10`}>
          <h2 className="font-bold text-sm sm:text-lg md:text-xs lg:text-lg xl:text-xl">
            {industries[0].title}
          </h2>


          <p className="text-[10px] sm:text-xs md:text-lg lg:text-xs xl:text-sm text-center">
            {industries[0].description}
          </p>
        </div>


        {/* FINTECH */}
        <IndustryCircle
          title={industries[1].title}
          description={industries[1].description}
          className={`left-[30%] top-[15%] md:left-[35%] md:top-[20%] lg:top-[20%] lg:left-[34%] -translate-x-1/2 -translate-y-1/2 ${outerCircleSizeClass}`}
          onClick={() => navigate('/industryfintech')}
        />


        {/* SECOND */}
        <IndustryCircle
          title={industries[2].title}
          description={industries[2].description}
          className={`left-[30%] top-[78%] md:left-[35%] md:top-[75%] lg:top-[77%] lg:left-[34%] -translate-x-1/2 -translate-y-1/2 ${outerCircleSizeClass}`}
        />


        {/* HEALTHCARE */}
        <IndustryCircle
          title={industries[3].title}
          description={industries[3].description}
          className={`left-[75%] top-[48%] md:left-[70%] md:top-[50%] lg:top-[50%] lg:left-[79%] -translate-x-1/2 -translate-y-1/2 ${outerCircleSizeClass}`}
          onClick={() => navigate('/industryhealthcare')}
        />


      </div>
    </div>
  )
}


export default Industries